import { CommonModule } from '@angular/common';
import { Component, ContentChild, Input, OnChanges, SimpleChanges, TemplateRef, ViewChild } from '@angular/core';
import { checkIsDirty } from '../../../utils/searchCriteriaUtils';

@Component({
  selector: 'app-filter-panel',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './filter-panel.component.html',
  styleUrl: './filter-panel.component.scss'
})
export class FilterPanelComponent<T> implements OnChanges {

  @ViewChild('filterAccordion') filterAccordion: any;

  @ContentChild("fields")
  fields!: TemplateRef<any>;

  searchCriteriaDirty: boolean = false;

  @Input()
  criteria: T | undefined;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['criteria']) {
      this.searchCriteriaDirty = (this.criteria && checkIsDirty(this.criteria)) ?? false;
      if (this.searchCriteriaDirty) {
        //this.filterAccordion.nativeElement.classList.add('show');
      } else {
        //this.filterAccordion.nativeElement.classList.remove('show');
      }
    }
  }

  get context() {
    return this;
  }
}
